import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=2df201ba&scoped=true&lang=pug"
import script from "./UserSettings.js?vue&type=script&lang=js&external"
export * from "./UserSettings.js?vue&type=script&lang=js&external"
import style0 from "./UserSettings.sass?vue&type=style&index=0&id=2df201ba&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df201ba",
  null
  
)

export default component.exports